import ActionType from '../actions/ActionType'
import { camelCase, omit } from 'lodash'

export default (
	state = {
		lastIntent: '',
		lastQuery: '',
	},
	action,
) => {
	switch (action.type) {
		case ActionType.PREDICTIONS.GET_SUCCESS:
			return {
				...state,
				[camelCase(action.payload.body.topScoringIntent.intent)]:
					action.payload.body,
				lastQuery: action.payload.body.query,
				lastIntent: camelCase(action.payload.body.topScoringIntent.intent),
				predictions: action.payload.body
			}
		case ActionType.PREDICTIONS.CONSUME_PREDICTION:
			return omit(
				{
					...state,
					lastQuery: '',
					lastIntent: '',
				},
				camelCase(action.intent),
			)
		default:
			return state
	}
}
